import React, {useContext} from "react";
import InvetoryList from "./ManageOrShowInventory";
import EstimateJobCharges from "./EstimateJobCharges";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import parse from "html-react-parser";

export default () => {
    return (
        <div className="contact-information mt-4">
            <ul className="contact-info-list pl-0 mb-0">
                <JobDetails/> {/* this component shows Job charges (Move Type,Residential Move,Move Size,SqFt,Trucks
                 ,Crew Size,Hourly Min and inventory) */}
                <EstimateJobCharges/>  {/* this component shows the estimate job charges  */ }
            </ul>
        </div>
    )
};

const  JobDetails = () => {
    let RecordsController = useContext(RecordsManagementContext)
    let EstimateDetails = RecordsController.CP_PageDetails.EstimateDetails
    let Estimate = EstimateDetails.JobDetails
    Estimate = Estimate.JobDetails == undefined ? Estimate : Estimate.JobDetails
    let PageView = useContext(ViewMangementContext)
    let IsJobOpen = useContext(RecordsManagementContext).IsJobOpen
    let isUpdateInventory = RecordsController.CP_PageDetails.editFields.inventory

    //when we click on "Manage Inventory/show Inventory" the modal will render
    const ShowOrManageInventory = () => {
        PageView.setModalContent({
            Title: IsJobOpen  ? 'Manage Inventory' : 'Show Inventory',
            Class: IsJobOpen  ? 'inventory-list' : Estimate.PriceChecklistInventoryType ? "percentage-inventory" : 'inventory-record',
            Body: <InvetoryList Functionality={IsJobOpen ? "Manage" : "Show"}/>
        })
    }
    const Details = (props) => {
        if (props.Show) {
            return (
                <li>
                    <span className='move-ty'>{props.Label}</span>
                    <span>{props.Value}</span>
                </li>
            )
        } else {
            return (<></>)
        }
    }
    return (<>
            <li><h6>Job Details </h6></li>
            <li>
                <div className="row">
                    <div className="col-sm-5">
                        <div className="job-details-wrp">
                            <ul className="job-type-list pl-0 mb-0">
                                <Details Show={Estimate.ShowMeasurement} Label='Move Type:' Value={Estimate.TypeOfService}/>
                                <Details Show={Estimate.ShowMeasurement} Label='Move Size:' Value={Estimate.MoveSize}/>
                                <Details Show={Estimate.ShowMeasurement} Label={Estimate.IsSqFt ? 'SqFt:' : "SqM:"} Value={Estimate.SqFt}/>
                                <Details Show={!IsJobOpen && Estimate.showCrewAndTrucks} Label='Trucks:' Value={Estimate.Trucks + " Truck(s)"}/>
                                <Details Show={!IsJobOpen && Estimate.showCrewAndTrucks} Label='Crew Size:' Value={Estimate.Crews + " " + Estimate.CrewMemberVerbiage}/>
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-7">
                        <div className="inventory">
                            <span>Inventory</span>
                            { Estimate.ShowMeasurement ?
                                <h6 className="py-2 head-h6"> {parse(`${Estimate.CuftSqft}`)}</h6> : ""}
                            <div className="inventory-deatils">
                                <span>{Estimate.Rooms} Rooms</span>
                                <span>{Estimate.Items} {Estimate.PriceChecklistInventoryType ? " O/S items" : "Items"}</span>
                                { Estimate.hideBoxes ?
                                <span>{Estimate.Boxes} Boxes</span> : ""}
                            </div>

                            {/*Disable and stop the functionality of 'Inventory' button if PriceChecklist InventoryType is true.*/}
                            { isUpdateInventory || !IsJobOpen ?
                            <button className={"update-btn"}
                                    data-toggle={"modal"}
                                    data-target={"#Modal"}
                                    onClick={() => ShowOrManageInventory()}>
                                {IsJobOpen ? 'Manage Inventory' : 'Show Inventory'}
                            </button> : <></> }
                        </div>
                    </div>
                </div>
            </li>
        </>
    )
}

